module.exports = __webpack_public_path__ + "static/media/mobile-btn-download-apple.b91984f4.svg";